import { render, staticRenderFns } from "./FieldSchemapropertyselector.vue?vue&type=template&id=494655c3&scoped=true&"
import script from "./FieldSchemapropertyselector.vue?vue&type=script&lang=js&"
export * from "./FieldSchemapropertyselector.vue?vue&type=script&lang=js&"
import style0 from "./FieldSchemapropertyselector.vue?vue&type=style&index=0&id=494655c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494655c3",
  null
  
)

export default component.exports